import * as React from "react";
import type { SVGProps } from "react";
const SvgAiLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#0521FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.015 8.014 13.17 6.86a2.848 2.848 0 1 0-4.027-4.027L6.674 5.3a2.847 2.847 0 0 0 0 4.027l-.007.008c.23.225.497.41.789.545"
    />
    <path
      stroke="#0521FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.538 6.128c.292.135.56.32.789.545a2.846 2.846 0 0 1 0 4.028l-2.468 2.467a2.848 2.848 0 0 1-4.027-4.027l1.154-1.154"
    />
  </svg>
);
export default SvgAiLink;
